<template>
  <div class="section-change">
    <div class="col-8 col-lg-8 col-xl-5 mx-auto py-xl-2">
      <form-order :title="$gettext('Change Table/Room/Cover')" :isChangeOrder="true"/>
    </div>
  </div>
</template>

<script>
import FormOrder from '@/components/FormOrder.vue';

export default {
  name: 'ChangeOrder',
  components: {
    FormOrder,
  },
  created() {
    if (!this.$store.state.bill.bill.id) {
      this.$router.push('order');
    }
  },
};
</script>
